import { ExclamationTriangleIcon } from '@heroicons/react/24/outline';
import { useTranslation } from 'react-i18next';
import { Button, Dialog, DialogContent, DialogTitle } from '../../atoms';
import { cn, useBreakpoints } from '@jobcost-monorepo/utils';

interface Props {
  isOpen: boolean;
  handleClose: () => void;
  handleDelete: () => void;
  loader?: boolean;
  customTitle?: string;
  customDescription?: string;
  customCloseMessage?: string;
  customDeleteMessage?: string;
}

const ModalDelete = ({
  isOpen,
  handleClose,
  handleDelete,
  customTitle,
  customDescription,
  customCloseMessage,
  customDeleteMessage,
  loader,
}: Props) => {
  const { t } = useTranslation('commons');
  const title = customTitle || t('deleteModal.title');
  const description = customDescription || t('deleteModal.description');
  const closeMessage = customCloseMessage || t('deleteModal.cancel');
  const deleteMessage = customDeleteMessage || t('deleteModal.confirm');
  const { isSmall } = useBreakpoints();

  return (
    <Dialog open={isOpen} onOpenChange={handleClose}>
      <DialogContent
        onClick={handleClose}
        className="relative transform overflow-hidden rounded-lg mx-5 border border-gray dark:border-lightGray  bg-white dark:bg-dark px-4 pt-5 pb-4 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg sm:p-6"
      >
        <div className="sm:flex sm:items-start">
          <div className="mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full sm:mx-0 sm:h-10 sm:w-10">
            <ExclamationTriangleIcon
              className="h-6 w-6 text-red"
              aria-hidden="true"
            />
          </div>
          <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
            <DialogTitle className="text-base font-semibold leading-6">
              {title}
            </DialogTitle>
            <div className="mt-2">
              <p className="text-sm dark:text-slate-50">{description}</p>
            </div>
          </div>
        </div>
        <div className="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
          <Button
            type="button"
            className={cn(isSmall ? 'w-full' : 'w-max')}
            onClick={handleDelete}
            disabled={loader}
            loading={loader}
          >
            {deleteMessage}
          </Button>
          <Button
            type="button"
            className="mt-3 mr-3 inline-flex w-full justify-center rounded-md bg-white  px-3 py-2 text-black shadow-sm border border-black hover:opacity-50 dark:hover:opacity-100 hover:bg-white dark:hover:border-slate-800 sm:mt-0 sm:w-auto"
            onClick={handleClose}
            disabled={loader}
          >
            {closeMessage}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ModalDelete;
